import React from 'react';
import {withTranslation} from 'react-i18next';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import ModalManager from './ModalManager';

class ModalWrapper extends React.Component {
  constructor(props) {
    super(props);
  }

  close() {
    ModalManager.close({
      isOpen: false
    });
  }

  render() {
    const {t, data} = this.props;
    return (
      <div>
        {/*<Button color="danger" onClick={this.close}>{t('close')}</Button>*/}
        <Modal isOpen={data.isOpen} toggle={this.close}>
          <ModalHeader toggle={this.toggle}>{data.title}
          </ModalHeader>
          <ModalBody>{data.body}</ModalBody>
          <ModalFooter>
            {data.buttons && data.buttons.length ?
              data.buttons.map(button => <Button color={button.color} onClick={button.onClick}>{button.text}</Button>)
              : null}
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default withTranslation()(ModalWrapper);
